export default __webpack_public_path__ + "static/media/MICIAL.89b26098.jpg";